export const COMMON_FILTERS_WIDGET_NAMESPACE = 'widget.common-filters'
